import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signInWithAuthentik } from "../Login/authentik";
import AuthContext from "../../AuthContext";
import "./Login.css";

function Login() {
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const requestedLocation = location.state?.from;
  const from = requestedLocation
    ? `${requestedLocation.pathname}${requestedLocation.search || ''}${requestedLocation.hash || ''}`
    : sessionStorage.getItem('postLoginRedirect') || "/dashboard";

  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) {
      sessionStorage.removeItem('postLoginRedirect');
      navigate(from, { replace: true });
    }
  }, [user, loading, navigate, from]);

  return (
    <div className="login">
      <div className="login__container">
        <button className="login__btn login__authentik" onClick={signInWithAuthentik}>
          Login with Authentik
        </button>
      </div>
    </div>
  );
}

export default Login;